// src/config/games.js
export const GAME_CONFIGS = {
    // 'PUBG: BATTLEGROUNDS': {  // 改用完整的游戏标题作为key
    '绝地求生_akm版本': {  // 改用完整的游戏标题作为key
        id: 'pubg',
        title: 'PUBG: BATTLEGROUNDS',
        image: '/cdk/pubg.png',
        loginMethods: [
            {
                id: 'steam',
                name: 'Steam登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Steam账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam账号'
                    },
                    {
                        name: 'password',
                        label: 'Steam密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入Steam密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: '令牌验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam令牌验证码'
                    }
                },
                // 添加验证配置
                verify: {
                    // api: '/api/steam/login/',
                    api: '/api/steam/login_repeat',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password
                    })
                },
                // 提交配置
                submit: {
                    // api: '/api/steam/valid_login/',
                    api: '/api/steam/login_repeat',
                    // api: '/api/twitch/pubg/steam_login',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.email_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.token_code = formData.tokenCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/pubg/steam_claim',
                    transformData: (formData) => {
                        // 过滤 cdkey: 去除空格，只保留允许的字符
                        // const filteredCdkey = formData.cdkey
                        //   .trim()
                        //   .replace(/\s+/g, '')
                        //   .replace(/[^A-Za-z0-9:]/, '')
                        //   .slice(8, 48); // 假设限制长度为50个字符，你可以根据需求调整
                        const data = {
                            // job_id: formData.jobId,
                            username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            },
            {
                id: 'krafton',
                name: 'Krafton账号',
                fields: [
                    {
                        name: 'username',
                        label: '邮箱/账号/全球账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Krafton账号邮箱'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                extraFields: {},
                // Krafton的验证配置
                // verify @Deprecated
                // Krafton的提交配置
                submit: {
                    // 提交登录任务
                    api: '/api/twitch/pubg/akmlogin',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password,
                        cdkey: formData.cdkey
                    })
                },
                claim: {
                    api: '/api/twitch/pubg/claim',
                    transformData: (formData) => {
                        const data = {
                            // job_id: formData.jobId,
                            username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            },
        ],
    },
    '绝地求生': {  // 改用完整的游戏标题作为key
        id: 'pubg',
        title: 'PUBG: BATTLEGROUNDS',
        image: '/cdk/pubg.png',
        loginMethods: [
            {
                id: 'steam',
                name: 'Steam登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Steam账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam账号'
                    },
                    {
                        name: 'password',
                        label: 'Steam密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入Steam密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: '令牌验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam令牌验证码'
                    }
                },
                // 添加验证配置
                verify: {
                    // api: '/api/steam/login/',
                    api: '/api/steam/login_repeat',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password
                    })
                },
                // 提交配置
                submit: {
                    // api: '/api/steam/valid_login/',
                    api: '/api/steam/login_repeat',
                    // api: '/api/twitch/pubg/steam_login',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.email_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.token_code = formData.tokenCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/pubg/steam_claim',
                    transformData: (formData) => {
                        // 过滤 cdkey: 去除空格，只保留允许的字符
                        // const filteredCdkey = formData.cdkey
                        //   .trim()
                        //   .replace(/\s+/g, '')
                        //   .replace(/[^A-Za-z0-9:]/, '')
                        //   .slice(8, 48); // 假设限制长度为50个字符，你可以根据需求调整
                        const data = {
                            // job_id: formData.jobId,
                            username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            },
            {
                id: 'krafton',
                name: 'Krafton账号',
                fields: [
                    {
                        name: 'world_username',
                        label: '邮箱/账号/全球账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Krafton账号邮箱'
                    },
                    {
                        name: 'world_password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                extraFields: {},
                // Krafton的验证配置
                verify: {
                    // 提交登录任务
                    api: '/api/twitch/pubg/login',
                    transformData: (formData) => ({
                        world_username: formData.world_username,
                        world_password: formData.world_password,
                        cdkey: formData.cdkey
                    })
                },
                // Krafton的提交配置
                submit: {
                    // api: '/api/pubg/krafton/redeem',
                    api: '/api/twitch/pubg/query',
                    transformData: (formData) => ({
                        job_id: formData.jobId
                    })
                },
                claim: {
                    api: '/api/twitch/pubg/claim',
                    transformData: (formData) => {
                        const data = {
                            job_id: formData.jobId,
                            username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            },
        ],
    },
    'Party Animals': {  // 使用完整的游戏标题
        id: 'party-animals',
        title: 'Party Animals',
        image: '/cdk/party-animals.jpg',
        loginMethods: [
            {
                id: 'default',
                name: '游戏账号登录',
                fields: [
                    {
                        name: 'username',
                        label: '用户名',
                        type: 'text',
                        required: true,
                        placeholder: '请输入游戏用户名'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // Party Animals的提交配置
                submit: {
                    api: '/api/party-animals/redeem',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password,
                        cdkey: formData.cdkey
                    })
                }
            }
        ],
    },
    'Rust': {
        id: 'rust',
        title: 'Rust',
        image: '/cdk/rust.jpg',
        loginMethods: [
            {
                id: 'steam',
                name: 'steam账号登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Steam 账户',
                        type: 'text',
                        required: true,
                        placeholder: '请输入账户'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: '令牌验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam令牌验证码'
                    }
                },
                // 添加验证配置
                verify: {
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password
                    })
                },
                // 提交配置
                submit: {
                    // api: '/api/steam/valid_login/',
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.email_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.token_code = formData.tokenCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/rust/claim_persistent',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            cdkey: formData.cdkey,
                            response_type: "simplify"
                        }
                        return data
                    }
                }
            }
        ],
    },
    'Rainbow Six Sixge': {
        id: 'rainbow-six-sixge',
        title: 'Rainbow Six Sixge',
        image: '/cdk/rainbow-six-sixge.jpg',
        loginMethods: [
            {
                id: 'Ubisoft',
                name: 'Ubisoft账号登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Ubisoft 账户',
                        type: 'text',
                        required: true,
                        placeholder: '请输入账户'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: 'Google Auth 验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Google Authenticator Code'
                    },
                    smsCode: {
                        name: 'smsCode',
                        label: '短信验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入手机短信验证码'
                    }
                },
                // 添加验证配置
                verify: {
                    api: '/api/ubisoft/rainbow6/verify',
                    transformData: (formData) => ({
                        ubi_username: formData.username,
                        ubi_password: formData.password,
                        cdkey: formData.cdkey
                    })
                },
                // 提交配置
                submit: {
                    api: '/api/ubisoft/rainbow6/valid',
                    transformData: (formData) => {
                        const data = {
                            ubi_username: formData.username,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.valid_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.valid_code = formData.tokenCode
                        }
                        if (formData.smsCode) {
                            data.valid_code = formData.smsCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/rainbow6/claim',
                    transformData: (formData) => {
                        const data = {
                            ubi_username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            }
        ],
    },
    'Hunt: showdown': {
        id: 'hunt-showdown',
        title: 'Hunt: showdown',
        image: '/cdk/rainbow-six-sixge.jpg',
        loginMethods: [
            {
                id: 'Steam',
                name: 'Steam账号登录',
                fields: [
                    {
                        name: 'username',
                        label: 'Steam 账户',
                        type: 'text',
                        required: true,
                        placeholder: '请输入账户'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // 添加额外的验证字段配置
                extraFields: {
                    emailCode: {
                        name: 'emailCode',
                        label: '邮箱验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入邮箱验证码'
                    },
                    tokenCode: {
                        name: 'tokenCode',
                        label: '令牌验证码',
                        type: 'text',
                        required: true,
                        placeholder: '请输入Steam令牌验证码'
                    }
                },
                // 添加验证配置
                verify: {
                    // api: '/api/steam/login/',
                    // api: '/api/steam/login_repeat',
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => ({
                        username: formData.username,
                        password: formData.password
                    })
                },
                // 提交配置
                submit: {
                    // api: '/api/steam/valid_login/',
                    // api: '/api/steam/login_repeat',
                    api: '/api/steam/login_persistent',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        if (formData.emailCode) {
                            data.email_code = formData.emailCode
                        }
                        if (formData.tokenCode) {
                            data.token_code = formData.tokenCode
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/hunt/claim',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                }
            }
        ],
    },
    'Soulframe': {
        id: 'soulframe',
        title: 'Soulframe',
        image: '/cdk/sf_2.png',
        loginMethods: [
            {
                id: 'OfficialAccount',
                name: '官方账号登录',
                fields: [
                    {
                        name: 'username',
                        label: '官方账号',
                        type: 'text',
                        required: true,
                        placeholder: '请输入账号'
                    },
                    {
                        name: 'password',
                        label: '密码',
                        type: 'password',
                        required: true,
                        placeholder: '请输入密码'
                    },
                    {
                        name: 'cdkey',
                        label: 'CDKey',
                        type: 'text',
                        required: true,
                        placeholder: '请输入CDKey'
                    }
                ],
                // // 添加验证配置
                // verify: {
                //   api: '/api/twitch/soulframe/bind',
                //   transformData: (formData) => ({
                //     username: formData.username,
                //     password: formData.password,
                //     cdkey: formData.cdkey
                //   })
                // },
                // 提交配置
                submit: {
                    api: '/api/twitch/soulframe/bind',
                    transformData: (formData) => {
                        const data = {
                            username: formData.username,
                            password: formData.password,
                            cdkey: formData.cdkey
                        }
                        return data
                    }
                },
                claim: {
                    api: '/api/twitch/soulframe/bind',
                    transformData: (formData) => {
                        // const data = {
                        //     username: formData.username,
                        //     password: formData.password,
                        //     cdkey: formData.cdkey
                        // }
                        return {
                            "success": true,
                            "code": 1,
                            "message": "You got one!"
                        }
                    }
                }
            }
        ],
    }
}